/** Which build this is, injected at compile time by vite.config.ts.
 *
 *  Exists because on 2026-07-27 two deployments in a row shipped an old bundle —
 *  the folder on disk and the folder in the download had drifted apart, and both
 *  uploads reported success. Nothing on screen could tell them apart. */
declare const __BUILD__: string;
export const BUILD = typeof __BUILD__ === 'string' ? __BUILD__ : 'dev';
